import apiHandler from "../core/apiHandler";

const dteTestRequirementApi = apiHandler("dte/test-requirements");
export default dteTestRequirementApi;
